import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Exam Forms/Admit Card</h1>
                <p>Home &gt;  Exam Forms/Admit Card</p>
            </div>
        </div>
    )
}

export default Hero;